if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
        };
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.closeSelector.bind(this));
        this.elements.button.addEventListener('click', this.openSelector.bind(this));

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      connectedCallback() {
        if (!this.closest('footer.footer')) return;
        this.footerOutsidePointer = (event) => {
          if (!this.contains(event.target) && this.elements.button.getAttribute('aria-expanded') === 'true') this.hidePanel();
        };
        this.footerFit = () => this.fitFooterDropdown();
        document.addEventListener('pointerdown', this.footerOutsidePointer);
        window.addEventListener('resize', this.footerFit, { passive: true });
        window.visualViewport?.addEventListener('resize', this.footerFit, { passive: true });
        window.visualViewport?.addEventListener('scroll', this.footerFit, { passive: true });
      }

      disconnectedCallback() {
        if (!this.footerOutsidePointer) return;
        document.removeEventListener('pointerdown', this.footerOutsidePointer);
        window.removeEventListener('resize', this.footerFit);
        window.visualViewport?.removeEventListener('resize', this.footerFit);
        window.visualViewport?.removeEventListener('scroll', this.footerFit);
      }

      fitFooterDropdown() {
        if (!this.closest('footer.footer')) return;
        const panel = this.elements.panel;
        for (const name of ['--fc-popup-shift', '--fc-popup-y', '--fc-popup-height', '--fc-popup-list-height']) panel.style.removeProperty(name);
        panel.classList.remove('fc-footer-popup-below');
        if (this.mql.matches || panel.hasAttribute('hidden')) return;
        const viewport = window.visualViewport;
        const viewLeft = viewport?.offsetLeft || 0;
        const viewTop = viewport?.offsetTop || 0;
        const viewWidth = viewport?.width || document.documentElement.clientWidth;
        const viewHeight = viewport?.height || window.innerHeight;
        const button = this.elements.button.getBoundingClientRect();
        const above = Math.max(0, button.top - viewTop - 30);
        const below = Math.max(0, viewTop + viewHeight - button.bottom - 30);
        const openBelow = above < 160 && below > above;
        panel.classList.toggle('fc-footer-popup-below', openBelow);
        const available = Math.min(openBelow ? below : above, viewHeight - 40);
        const height = Math.max(40, Math.min(275, available));
        const filterHeight = this.querySelector('.country-filter')?.offsetHeight || 0;
        panel.style.setProperty('--fc-popup-height', height + 'px');
        panel.style.setProperty('--fc-popup-list-height', Math.max(40, Math.min(205, height - filterHeight)) + 'px');
        const box = panel.getBoundingClientRect();
        let x = Math.min(0, viewLeft + viewWidth - 20 - box.right);
        if (box.left + x < viewLeft + 20) x = viewLeft + 20 - box.left;
        let y = Math.min(0, viewTop + viewHeight - 20 - box.bottom);
        if (box.top + y < viewTop + 20) y = viewTop + 20 - box.top;
        panel.style.setProperty('--fc-popup-shift', x.toFixed(3) + 'px');
        panel.style.setProperty('--fc-popup-y', y.toFixed(3) + 'px');
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }
        if (!this.closest('footer.footer')) {
          document.body.classList.remove('overflow-hidden-mobile');
          document.querySelector('.menu-drawer').classList.remove('country-selector-open');
          this.header.preventHide = false;
        }
        this.fitFooterDropdown();
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case 'SPACE':
            if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
            this.openSelector();
            break;
        }
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
        if (!this.closest('footer.footer') && !document.body.classList.contains('overflow-hidden-tablet')) {
          document.body.classList.add('overflow-hidden-mobile');
        }
        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }
        if (this.hasAttribute('data-prevent-hide')) {
          this.header.preventHide = true;
        }
        if (!this.closest('footer.footer')) document.querySelector('.menu-drawer').classList.add('country-selector-open');
        this.fitFooterDropdown();
      }

      closeSelector(event) {
        // Mobile touch can blur with no next focus just before the same box receives its click.
        // Real outside taps are already handled by the footer's document pointerdown listener.
        if (
          this.closest('footer.footer') &&
          !this.mql.matches &&
          event.relatedTarget === null &&
          this.contains(event.target) &&
          !event.target.classList.contains('country-selector__overlay')
        ) return;
        if (
          event.target.classList.contains('country-selector__overlay') ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          this.hidePanel();
        }
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }

      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a');
        let visibleCountries = allCountries.length;

        this.elements.resetButton.classList.toggle('hidden', !searchValue);

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', searchValue);
        }

        allCountries.forEach((item) => {
          const countryName = this.normalizeString(item.querySelector('.country').textContent);
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove('hidden');
            visibleCountries++;
          } else {
            item.parentElement.classList.add('hidden');
            visibleCountries--;
          }
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCountries
          );
        }

        this.querySelector('.country-selector').scrollTop = 0;
        this.querySelector('.country-selector__list').scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }
    }
  );
}
